module.exports = __webpack_public_path__ + "static/sport/slide4.08fad82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/slide4.png
// module id = 8ux0
// module chunks = 0